import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Only include variant, sizes, and color
type ButtonBaseProps = Pick<
  MuiButtonProps,
  | "variant"
  | "size"
  | "color"
  | "fullWidth"
  | "endIcon"
  | "startIcon"
  | "disabled"
  | "disableRipple"
  | "sx"
  | "onClick"
>;

// Use all except disableRipple
export interface IButtonProps extends ButtonBaseProps {
  text: string;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
}

const MButton = ({ text, type, loading = false, ...rest }: IButtonProps) => {
  const theme = useTheme();

  return (
    <MuiButton {...rest} type={type} disabled={rest.disabled || loading}>
      {loading ? (
        <CircularProgress
          size={24}
          sx={{
            color: "text.secondary",
          }}
        />
      ) : (
        <Typography
          variant="sectionTitle"
          sx={{
            textTransform: "none",
            fontSize: {
              xs: "0.45rem",
              sm: "0.50rem",
              md: "0.55rem",
            },
            [theme.breakpoints.up("lg")]: {
              fontSize: "0.85rem",
            },
          }}
        >
          {text}
        </Typography>
      )}
    </MuiButton>
  );
};

export default MButton;
